const slugPattern = /[^a-z0-9]+/g;
const escapeHtmlAttribute = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export const slugify = (value) => {
  const normalized = String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(slugPattern, "-")
    .replace(/^-+|-+$/g, "");

  return normalized || "user";
};

export const buildUserSlug = (user = {}) => {
  const fullName = String(
    user.fullName || user.full_name || user.name || user.displayName || "",
  ).trim();
  return slugify(fullName || user.id || "user");
};

export const resolveUserSlug = (user = {}) => {
  const slug = String(user.slug || user.userSlug || "").trim();
  return slug || buildUserSlug(user);
};

export const buildUserFullName = (user = {}) => {
  const fullName = String(
    user.fullName || user.full_name || user.name || "",
  ).trim();

  return fullName;
};

export const generateUserId = (users = []) => {
  const maxNumber = (Array.isArray(users) ? users : []).reduce((max, user) => {
    const value = Number(String(user?.id || "").replace(/^\D+/g, "")) || 0;
    return Math.max(max, value);
  }, 1000);

  return `DPU-${String(maxNumber + 1).padStart(4, "0")}`;
};

export const normalizeUser = (user) => {
  if (!user || typeof user !== "object") {
    return null;
  }

  const fullName = buildUserFullName(user);
  const slug = String(user.slug || user.userSlug || "").trim();
  const passwordCode = String(user.passwordCode || user.password_code || "").trim();

  return {
    id: String(user.id || ""),
    fullName,
    slug,
    passwordCode,
    iframeCode: String(user.iframeCode || user.iframe_code || ""),
    status: user.status === "inactive" ? "inactive" : "active",
    createdAt: user.createdAt || user.created_at || null,
    updatedAt: user.updatedAt || user.updated_at || null,
  };
};

export const normalizeIframeMarkup = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) {
    return "";
  }

  const srcMatch = trimmed.match(/src\s*=\s*["']([^"']+)["']/i);
  const src = srcMatch?.[1] || trimmed;

  return `<iframe src="${escapeHtmlAttribute(src)}" title="Embedded content" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
};

export const normalizeUsers = (users = []) =>
  Array.isArray(users)
    ? users.map(normalizeUser).filter(Boolean)
    : [];
